import React, { useEffect } from 'react';

export default function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="contact-page">
      <div className="">
        <div className="container">
            <div className="request_consult_inner">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="request_consult_left">
                            <h2>Revival Pharmacy is a leading life sciences </h2>
                            <p>One goal of our Pharmacy is to be there when you need us. </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
      </div>
    <div className="department_with_sidebar">
        <div className="container">
            <div className="row">

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="departmet_sidebar_right">
                        <h1>Our Services</h1>

                        <div className="department_right_content">
                            <div className="content_one">
                                <p className="text-justify">
                                    Discover Revival Pharmacy, your trusted partner in Regina, committed to delivering outstanding patient care to our local community and beyond. With a dedicated team of over 10 pharmacists, we ensure personalized attention and accurate prescription fulfillment.
                                    <br /><br />
                                    At Revival Pharmacy, your health and safety are paramount. We meticulously review and verify your prescriptions, collaborate with your healthcare provider, and conduct thorough medication assessments to prevent any potential interactions.
                                    <br /><br />
                                    Our pharmacists undergo specialized training to cater to diverse healthcare needs, united by a common goal: providing you with unparalleled care. We prioritize your comfort, knowledge, and confidence in your treatment plan.
                                    <br /><br />
                                    Accessibility is key at Revival Pharmacy. We prioritize prompt responses to your inquiries and refill requests during our business hours, ensuring you receive the support you need when you need it.
                                    <br /><br />
                                    Trust Revival Pharmacy to prioritize your well-being and guide you towards a healthier lifestyle.
                                </p>

                            </div>
                            <div className="type_treatment">





                                <div className="row mb-4">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Prescriptive Authority</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>Revival Pharmacy extends Prescriptive Authority to assist patients with chronic medication needs. Our experienced pharmacists can prescribe most medications for one month, ensuring uninterrupted access to crucial medications.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Minor Ailments Prescribing</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>Count on our trained pharmacists at Revival Pharmacy to diagnose and prescribe medications for minor ailments such as Urinary Tract Infections (UTI). Reach out to discover how we can provide relief and assistance.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Free Blister Packing</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>For enhanced medication adherence, Revival Pharmacy offers complimentary Blister Packing services. Let us simplify your medication routine by organizing your pills into convenient bubble packs with designated time slots for each dose.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Vaccination Services</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>Revival Pharmacy provides comprehensive vaccination services, including flavoring medications for children and preparing medications for pets. Benefit from our compounding services, offering a diverse range of formulations such as capsules, gels, creams, ointments, solutions, and suspensions.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Diabetic Counseling</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>Empower yourself with effective diabetes management strategies at Revival Pharmacy. Our pharmacists offer personalized guidance on diet, medication, blood glucose monitoring, and other essential aspects to help you navigate your diabetes journey with confidence.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-header alert-success">
                                                <h2>Compression Stocking Fittings</h2>
                                            </div>
                                            <div className="card-body">
                                                <p>Experience optimal comfort and effectiveness with custom-fitted compression stockings from Revival Pharmacy. Our expert team ensures precise measurements to guarantee a perfect fit, enhancing your overall well-being.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}
